import liff from '@line/liff'
import { LineLinkService, OrderService } from '@/services'
import shopMixin from '@/mixins/shop'
import { AMAZON } from '@/constants/amazon'
import { cloneDeep } from 'lodash'
import { trimCommaForm } from '@/utils'

export default {
  mixins: [shopMixin],
  computed: {
    customerData() {
      return this.$store.state.register.customer
    },
    corporateFlag() {
      return this.$store.getters['auth/shop']?.corporate_flag
    },
  },
  methods: {
    restoreFromCookies() {
      this.form = cloneDeep(this.$cookies.get(AMAZON.CART_LINE029))
      this.$cookies.remove(AMAZON.CART_LINE029)
    },
    setCartToCookies() {
      // Set cookies 5min
      const form = cloneDeep(this.form)
      form.memberInformation.password = ''
      form.memberInformation.passwordConfirm = ''
      this.$cookies.set(AMAZON.CART_LINE029, form, 300)
    },

    onSubmit() {
      this.isSubmitTrim = true
      if (!this.user) {
        this.cloneCustomerInformation()
      }
      if (!this.corporateFlag && this.form.memberInformation.businessAccountFlag) {
        this.form.memberInformation.lastName = this.form.memberInformation.companyName
        this.form.memberInformation.firstName = ''
        this.form.memberInformation.lastNameKana = this.form.memberInformation.companyNameKana
        this.form.memberInformation.firstNameKana = ''
        this.form.shippingInformation.lastName = this.form.shippingInformation.companyName
        this.form.shippingInformation.firstName = ''
        this.form.shippingInformation.lastNameKana = this.form.shippingInformation.companyNameKana
        this.form.shippingInformation.firstNameKana = ''
      }

      this.form = {
        ...this.form,
        memberInformation: trimCommaForm(this.form.memberInformation, [
          'lastName',
          'firstName',
          'lastNameKana',
          'firstNameKana',
          'municipality',
          'address',
          'buildingApartmentName',
        ]),
        shippingInformation: trimCommaForm(this.form.shippingInformation, [
          'lastName',
          'firstName',
          'lastNameKana',
          'firstNameKana',
          'municipality',
          'address',
          'buildingApartmentName',
        ]),
      }

      this.$nextTick(() => {
        this.isSubmitTrim = false
        this.$refs.form.validate((valid, fields) => {
          this.isValidatePhoneNumberFlag = !!fields['memberInformation.phoneNumber']
          if (!valid) {
            let isValidateSection = null
            switch (true) {
              case Object.keys(fields).some((field) => field.startsWith('memberInformation')):
                isValidateSection = 'memberInformation'
                break
              case Object.keys(fields).some((field) => field.startsWith('shippingInformation')):
                isValidateSection = 'shippingInformation'
                break
              case Object.keys(fields).some((field) => field.startsWith('paymentInformation')):
                isValidateSection = 'paymentInformation'
                break
              default:
                isValidateSection = 'memberInformation'
                break
            }
            this.setScrollToSection(isValidateSection)
            this.handleError({ message: this.$t('common.messages.hasInvalidData') })
            return
          }

          // EC-12888 validate is select amazon but not login
          if (
            this.form.paymentInformation.methodOfPayment ===
              this.getPaymentIdByServiceId(this.Constants.PAYMENT_METHOD.AMAZON) &&
            !this.isLoginAmazon
          ) {
            this.handleError({ message: this.$t('common.messages.notYesLoginAmazon') })
            return
          }
          // Check if not checked consent amazon
          this.isLoginAmazon &&
            (this.form.paymentInformation.methodOfPayment = this.getPaymentIdByServiceId(
              this.Constants.PAYMENT_METHOD.AMAZON
            ))

          this.$nextTick(async () => {
            // Check cart empty
            if (!this.$store.state.cart.carts?.length) {
              this.$alert({
                message: this.$t('common.messages.cartEmpty'),
                type: 'error',
              })
              return
            }

            const loading = this.$loading({
              lock: true,
            })
            try {
              if (this.isLoginAmazon) {
                const amazonAmountLimit = this.isPeriodic ? AMAZON.SUBSCRIPTION_AMOUNT : AMAZON.NORMAL_AMOUNT

                if (this.total(this.saleType) > amazonAmountLimit) {
                  this.$alert({
                    message: this.$t('common.messages.totalOverAmazonAmount', {
                      limitedAmount: this.$n(amazonAmountLimit, 'currency', 'ja-JP'),
                    }),
                    type: 'error',
                  })
                  return
                }
              }

              if (this.total(this.saleType) > this.Constants.MAX_AMOUNT_TOTAL) {
                this.$alert({
                  message: this.$t('common.messages.totalOver1Billion'),
                  type: 'error',
                })
                return
              }

              // Verify if payment method is credit
              if (
                !this.form.paymentInformation.cardSeq &&
                this.getServiceIdByPaymentId(this.form.paymentInformation.methodOfPayment) ===
                  this.Constants.PAYMENT_METHOD.CREDIT_CARD
              ) {
                const isValid = await this.verifyCard()
                if (!isValid) return
              }

              this.fetchCartItems()

              OrderService.validEmail({
                email: this.form.memberInformation.email,
                customer_id: this.user?.id,
                payment_method: this.form.paymentInformation.methodOfPayment,
                payment_total: this.totalAmount,
              }).then(
                () => {
                  if (this.form?.shippingInformation) {
                    this.form.shippingInformation.time_note_disable_flag = this.isMailDeliveryService
                  }
                  this.$store.commit('register/SET_CUSTOMER', this.form)
                  this.$session[AMAZON.CART_LINE029] = JSON.stringify(this.form)
                  this.$session[AMAZON.SHIPPING_FEE] = this.shopShippingFee

                  this.$nextTick(async () => {
                    if (this.liffIdExists && this.isRequiredAdd) {
                      if (this.user) {
                        if (!this.user.line_id) {
                          this.visibleToBeFriend = true
                          return
                        } else {
                          const { data } = await LineLinkService.checkFriendLine(this.user.line_id)

                          if (
                            data.friend_status_id === this.Constants.FRIEND_STATUS.PERMISSION ||
                            data.friend_status_id === this.Constants.FRIEND_STATUS.NOT_ADD
                          ) {
                            this.visibleToBeFriend = true
                            return
                          }
                        }
                      } else {
                        if (!liff.isLoggedIn()) {
                          this.visibleToBeFriend = true
                          return
                        }

                        const { friendFlag } = await liff.getFriendship()

                        if (!friendFlag) {
                          this.visibleToBeFriend = true
                          return
                        }
                      }
                    }

                    this.$router
                      .push({
                        path: this.isPeriodic ? this.$routePage.EC_LINE004_001 : this.$routePage.EC_LINE004_002,
                      })
                      .catch(() => {})
                  })
                },
                (error) => {
                  this.handleError(error)
                }
              )
            } catch (error) {
              this.handleError(error)
            } finally {
              loading.close()
            }
          })
        })
      })
    },
    setScrollToSection(refName) {
      this.$nextTick(() => {
        const offsetTop = this.$refs[refName] ? this.$refs[refName].$el.offsetTop : 0
        if (offsetTop) {
          window.scroll({ behavior: 'smooth', top: offsetTop })
        }
      })
    },
  },
}
